import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { UrgentProvider, UrgentButton } from "./components/UrgentModal";
import Home from "./pages/Home";
import Services from "./pages/Services";
import MobileTesting from "./pages/MobileTesting";
import ServiceArea from "./pages/ServiceArea";
import About from "./pages/About";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import Payments from "./pages/Payments";
import RequestsView from "./pages/RequestsView";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App min-h-screen bg-background font-sans text-foreground">
      <BrowserRouter>
        <UrgentProvider>
          <ScrollManager />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/mobile-testing" element={<MobileTesting />} />
              <Route path="/service-area" element={<ServiceArea />} />
              <Route path="/about" element={<About />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/payments" element={<Payments />} />
              <Route path="/requests" element={<RequestsView />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
          <div className="h-16 sm:hidden" />
          <div
            data-testid="sticky-mobile-cta"
            className="fixed inset-x-0 bottom-0 z-40 border-t border-slate-200 bg-white/95 p-3 backdrop-blur-md sm:hidden"
          >
            <UrgentButton className="w-full justify-center" testId="sticky-need-testing-now-button" />
          </div>
          <Toaster position="top-center" richColors />
        </UrgentProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
